import CryptoJS from 'crypto-js'
import { getSignatureSecret } from '@/utils/runtime-config'

// Read at call time so an on-prem config.js loaded before the bundle is honoured
// regardless of module evaluation order. Fallback: build-time env constant.
function apiSignatureSecret() {
  return getSignatureSecret(process.env.VUE_APP_API_SIGNATURE_SECRET)
}

/**
 * 生成請求簽名（防止 API 被直接呼叫）
 *
 * ⚠️ 重要：簽名格式必須與後端完全一致（tests/contract.test.mjs 以 golden vector 鎖住）
 * 格式: HMAC-SHA256(reportId|timestamp|nonce, secret) —— 不含 lang
 * 注意：
 * 1. secret 必須與後端完全相同
 * 2. 拼接順序：reportId|timestamp|nonce（不包含 secret）
 * 3. secret 作為 HMAC 的密鑰，不參與消息拼接
 *
 * @param {string} reportId - 報告 ID (token)
 * @returns {object} { timestamp, nonce, signature }
 */
export function generateRequestSignature(reportId) {
  const timestamp = Date.now().toString()
  const nonce = generateNonce()
  
  // ✅ 簽名格式: HMAC-SHA256(reportId|timestamp|nonce, secret)
  // 注意：secret 是 HMAC 的密鑰，不參與消息拼接
  const message = `${reportId}|${timestamp}|${nonce}`
  const signature = CryptoJS.HmacSHA256(message, apiSignatureSecret()).toString()

  return {
    timestamp,
    nonce,
    signature
  }
}

/**
 * 生成隨機 nonce（防重放攻擊）
 * @returns {string}
 */
function generateNonce() {
  return Math.random().toString(36).substring(2, 15) + 
         Math.random().toString(36).substring(2, 15)
}

/**
 * 為請求添加簽名 headers
 * @param {object} headers - 原始 headers
 * @param {string} reportId - 報告 ID (token)
 * @param {string} lang - 語言參數（必須使用 URL 中的原始格式）
 * @returns {object} 添加簽名後的 headers
 */
export function addSignatureHeaders(headers, reportId, lang) {
  const { timestamp, nonce, signature } = generateRequestSignature(reportId, lang)
  
  return {
    ...headers,
    'X-Request-Timestamp': timestamp,
    'X-Request-Nonce': nonce,
    'X-Request-Signature': signature
  }
}
